export default "__VITE_ASSET__DcnBQBUf__"